import React, { createContext, useEffect, useState } from "react";

import { Redirect, Route, Switch, useHistory, useParams } from "react-router-dom";
import { Centros } from "../centros/index";
import { Investigador } from "../investigadores";
import { Inicio } from "../inicio";
import { universidades_engineData } from "../data";
import '../shared/css/fonts.css';

export const UniversityContext = createContext();
function AppRouter({match}) {
  const {u = null} = useParams();
  const history = useHistory();

  const [universidad, setUniversidad] = useState({});

  //Marca visita de google analytics
  /*
  const nombreUniversidad = ""+universidad.id;
  TagManager.dataLayer({
    dataLayer: {
      event: 'visita',
      pagePath: 'inicio',
      university: nombreUniversidad,
    },
  });*/

  const changeuniversity = (university) =>{
    const [seletedUniversity] = universidades_engineData.filter( universidad => universidad.id === university)
    if ( !!seletedUniversity ){
      //null,undefined,'',0,false
      setUniversidad( seletedUniversity )
    }else{
      //if we dont found a university in the global arr we assume that our user have a bad url (param) so we redirect it for a default one
      history.replace( '/caps/' )
    }
    
  }
  useEffect(() => {
    //to avoid problems with the routes we add "/" after the params to have a unified way to redirect the user
      if( !match.url.includes (`/${match.params.u}/`) )
      {
        history.replace(`/${match.params.u}/`);
      }
      var f = new Date();
      var d = ""+f.getFullYear()+"-"+f.getMonth()+"-"+f.getDay()+"-"+f.getHours()+"-"+f.getMinutes()+"-"+f.getSeconds();
      var head = document.head;
      const link = document.createElement("link");
      link.type = "text/css";
      link.rel = "stylesheet";
      link.href = `/css/${u}/overwride.css?d=`+d;
      head.appendChild(link);
      changeuniversity(u);
       // eslint-disable-next-line
    }, [u]);
  return (
    <UniversityContext.Provider value={ [universidad, setUniversidad] }>
      <div>
        <Switch>
          <Route path={ `${ match.path }`} exact component={Inicio} />
          <Route path={`${match.path}/investigador/`} component={Investigador} />
          <Route path={`${ match.path }/centro/`} component={Centros}/>
          <Redirect to={ `${ match.path }/`} />
        </Switch>
      </div>
    </UniversityContext.Provider>
  );
}

export default AppRouter 

